
import { useState, useEffect } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { validateContent } from "@/utils/contentValidation";

interface WritingContentValidatorProps {
  content: string;
  onValidationChange: (isValid: boolean) => void;
}

const WritingContentValidator = ({ content, onValidationChange }: WritingContentValidatorProps) => {
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (content.trim()) {
      const validation = validateContent(content);
      if (!validation.isValid) {
        setValidationError(validation.message || '');
        onValidationChange(false);
      } else {
        setValidationError('');
        onValidationChange(true);
      }
    } else {
      setValidationError('');
      onValidationChange(true);
    }
  }, [content, onValidationChange]);

  if (!validationError) return null;

  return (
    <Alert variant="destructive" className="mt-2">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{validationError}</AlertDescription>
    </Alert>
  );
};

export default WritingContentValidator;
